import React from 'react';
import { useTheme } from '@components/theme';
import classnames from 'classnames';
import styles from './CTA.module.scss';
import Stars from './assets/yellow-stars.svg';

export interface IFindYourStyleProps {
  size: string;
  className?: string;
  primaryTextClassName?: string;
  secondaryTextClassName?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function FindYourStyle({
  className,
  primaryTextClassName,
  secondaryTextClassName,
}: IFindYourStyleProps) {
  const theme = useTheme();
  return (
    <div className={
      classnames(
        styles.CTACard,
        className
      )
    }
    >
      <div className={styles.Contents}>
        <a href={'/interior-design-style-quiz'}>
          <Stars />
          <div className={
            classnames(theme.styles.Title2, styles.PrimaryText, primaryTextClassName)
          }
          >
            Find your style
          </div>
          <div className={classnames(styles.SecondaryText, secondaryTextClassName)}>
            Take our quiz.
          </div>
        </a>
        <div className={ styles.Overlay } />
      </div>
    </div>
  );
}
